<template>
    <div>
        <v-btn id="ODT-btn" :disabled="!canUseColorGradingTools" class="--disabled">
            <i class="material-icons">expand_less</i>
            <span class="menu-label">Output Transform</span>
            <v-icon class="material-symbols-outlined ml-1" size="18">desktop_mac</v-icon>
        </v-btn>

        <div id="ODT-menu-container" class="hide tools-menu-container scrollable-con">
<!--            <i class="arrow" data-popper-arrow></i>-->
            <div class="menu-items-container"></div>
        </div>
    </div>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";

export default {
    mixins: [CanMixin],
}
</script>

<style lang="scss" scoped>
#ODT-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 3px 8px !important;
    margin-right: -8px;

    &.--disabled,
    &.disabled {
        cursor: not-allowed;
    }

    > i {
        font-size: 18px;
    }

    > .menu-label {
        margin-left: 2px;
    }
}

.tools-menu-container {
    transition: none;
    display: block;
    position: absolute;
    padding: 15px 0;
    z-index: 20;
    height: 270px;
    min-width: 150px;
    background-color: #282828;
    box-shadow: 2px 2px 10px 0px #0e0e0e;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    cursor: pointer;

    > .menu-items-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        ::v-deep .menu-item {
            width: 100%;
            padding: 3px 20px;
            line-height: 1;
            transition: all 0.05s ease-in;
            // display: block;
            &:hover {
                transition: all 0.05s ease-in;
                background: rgb(54, 54, 54);
            }

            &.first {
                order: -1;
            }
        }
    }
}
</style>